import Vue from "vue";
import Vuex from "vuex";
import unit from "@/assets/js/common";
import Case from "./modules/caselist.js";
import Dictionary from "./modules/dictionary"; //字典
import Debinfo from "./modules/debInfo";
import Stages from "./modules/stages"; //分期弹窗操作
import Home from "./modules/home"; //首页
import getters from "./getters";
import DisForm from "./modules/disForm";
import setWatermark from "@/assets/js/watermark.js";
Vue.use(Vuex);
const state = {
  watermarks: {
    bg1: null,
    bg2: null,
  },
  user: localStorage.getItem("t")
    ? localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {}
    : {},
  StepLite: null,
  updateTime: null, //进度更新时间
  StepKey: null, //訴訟進度權限key
  editJA: false, //结案
  dislog: {
    filelist: false, //基本信息附件
    FileHistory: false, //保全记录
    call: false, //催收记录
    Other: false, //其他债务人信息
    Laysuit: false, //案件
    His: false, //沟通记录
    stepbox: false, //案件列表
    beforetime: false, //卷宗移交时间
    beforestart: false, //卷宗移交时间
    police: false,
    ones: false, //一审立案      二审立案
    twos: false, //一审 诉调
    three: false, //一审立案
    Fours: false, //一审待开庭
    Five: false,
    Six: false,
    Twelve: false, //再审
    Car: false, //车辆信息
    Fiveteen: false,
    reason: false, //作废原因
    Book: false,
  },
  Edit: false, //
  nineBool: false, //二审待开庭 是原告 还是被告
  cause: {}, //当前案件
};
export default new Vuex.Store({
  strict: true,
  state,
  getters,
  mutations: {
    SET_WATERMARKS(state, { bg1, bg2 }) {
      //设置背景水印
      state.watermarks.bg1 = bg1;
      state.watermarks.bg2 = bg2;
      // 存储到 localStorage
      localStorage.setItem("watermark_bg1", bg1);
      localStorage.setItem("watermark_bg2", bg2);
    },
    INIT_WATERMARKS(state) {
      const bg1 = localStorage.getItem("watermark_bg1");
      const bg2 = localStorage.getItem("watermark_bg2");
      if (bg1 && bg2) {
        state.watermarks.bg1 = bg1;
        state.watermarks.bg2 = bg2;
      }
    },
    //设置首页数字
    SETTIME(state, value) {
      //进度更新时间
      state.updateTime = value;
    },
    SETUser(state, value) {
      //用户 登录状态
      state.user = value;
    },
    SETKEY: (state, value) => {
      //设置key
      state[value.key] = value.value;
    },
    REMOVEKEY: (state, value) => {
      //删除key
      state[value] = null;
    },
    OPENKEY: (state, value) => {
      //弹窗开关
      state.dislog[value.key] = value.by;
    },
  },
  actions: {
    settime({ commit }, value) {
      commit("SETTIME", value);
    },
    setuser({ commit }, value) {
      commit("SETUser", value);
    },
    setkey({ commit }, value) {
      commit("SETKEY", value);
    },
    removekey({ commit }, value) {
      commit("REMOVEKEY", value);
    },
    openkey({ commit }, value) {
      commit("OPENKEY", value);
    },
    updateWatermarks({ commit, state }) {
      const bg1 = state.user.uname
        ? setWatermark(state.user.uname, state.user.phone || "", 1)
        : "";
      const bg2 = state.user.uname
        ? setWatermark(state.user.uname, state.user.phone || "", 2)
        : "";
      commit("SET_WATERMARKS", { bg1, bg2 });
    },
    loadWatermarks({ commit }) {
      commit("INIT_WATERMARKS");
    },
  },
  modules: {
    Case,
    Home,
    Dictionary,
    Debinfo,
    DisForm,
    Stages,
  },
});
